
import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const InventoryPage = lazy(() => import("../pages/inventory/page"));
const FinancingPage = lazy(() => import("../pages/financing/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const ServicePage = lazy(() => import("../pages/service/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/inventory",
    element: <InventoryPage />,
  },
  {
    path: "/financing",
    element: <FinancingPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/service",
    element: <ServicePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
